/// <amd-module name="Repos/Common/ProjectRepositoryInformationService" />
import { IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

export interface IProjectRepositoryInformation {
    defaultGitRepoName: string;
    defaultGitRepoUrl: string;
    defaultGitBranchName: string;
    defaultRepoIsGit: boolean;
    defaultRepoIsFork: boolean;
    defaultRepoId: string;
    supportsTfvc: boolean;
}

export interface IProjectRepositoryInformationService extends IVssService {
    /**
     * Get version control navigation data
     */
    getData: () => IProjectRepositoryInformation | undefined;

    /**
     * Get version control navigation data
     * @param ignoreCache True to fetch fresh information from server
     */
    getDataAsync(ignoreCache?: boolean): Promise<IProjectRepositoryInformation | undefined>;
}

class ProjectRepositoryInformationService extends VssService implements IProjectRepositoryInformationService {
    public getData(): IProjectRepositoryInformation | undefined {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getData<IProjectRepositoryInformation>("ms.vss-code-web.navigation-data-provider");
    }

    public getDataAsync(ignoreCache?: boolean): Promise<IProjectRepositoryInformation | undefined> {
        const contributionService = this.pageContext.getService<IVssContributionService>("IVssContributionService");
        return contributionService.getDataAsync<IProjectRepositoryInformation>("ms.vss-code-web.navigation-data-provider", undefined, ignoreCache);
    }
}

Services.add("IProjectRepositoryInformationService", { serviceFactory: ProjectRepositoryInformationService });
